export function triggerEvent(category, action, label) {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'gaTriggerEvent',
            gaEventCategory: category,
            gaEventAction: action,
            gaEventLabel: label
        });
    }
}

export function productsOnPage(products) {
    if (!Array.isArray(products)) {
        throw new Error('Expects Array of Products');
    }

    const expectedKeys = ['name', 'productClassId', 'itemId'];
    const hasKeys = products.every(product => expectedKeys.every(key => Object.prototype.hasOwnProperty.call(product, key)));

    if (!hasKeys) {
        throw new Error('All products must contain "name", "productClassId" and "itemId" keys');
    }

    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'productsOnPage',
            products
        });
    }
}